module.exports = __webpack_public_path__ + "img/final-success.79cdcdc1.png";